import {
    AUTH_LOGGING,
    AUTH_LOGGED,
    AUTH_LOGOUTED,
} from './actions'



let initialState = {

}

export const auth = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_LOGGING:
            break;
        case AUTH_LOGGED:
        case AUTH_LOGOUTED:
            let newState= {
                ...action.state,
            };
            return newState;
        default:
            return state;
    }
}




